import { render } from "./OrgSettingsDialogField.vue?vue&type=template&id=1768640d"
import script from "./OrgSettingsDialogField.vue?vue&type=script&lang=js"
export * from "./OrgSettingsDialogField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__